// extracted by mini-css-extract-plugin
module.exports = {"full-width-image-wrapper":"FullWidthContent_full-width-image-wrapper__wjwzQ"};